__turbopack_context__.v({
  "desktopSearch": "headerSearch-module-scss-module__WFsabq__desktopSearch",
});
